import {
  UploaderState,
  UploaderActionTypes,
  SELECT_FILES,
  REMOVE_FILES,
  FILE_UPLOAD_START,
  FILE_UPLOAD_SUCCESS,
  FILE_UPLOAD_ERROR,
  SELECT_SINGLE_FILE,
  REMOVE_SINGLE_FILE
} from './types';
import { Reducer } from 'redux';

export const initialState: UploaderState = {
  uploading: false,
  uploadError: false,
  selectedFiles: [],
  uploadedFiles: []
};

const uploaderReducer: Reducer<UploaderState, UploaderActionTypes> = (
  state = initialState,
  action
) => {
  switch (action.type) {
    case SELECT_FILES: {
      return {
        ...state,
        selectedFiles: [...state.selectedFiles, ...action.selectedFiles]
      };
    }
    case REMOVE_FILES: {
      const updatedFiles = [...state.selectedFiles];
      updatedFiles.splice(action.index, 1);

      return {
        ...state,
        selectedFiles: updatedFiles
      };
    }
    case SELECT_SINGLE_FILE: {
      const updatedFiles = [...state.selectedFiles];

      const indexOf = state.selectedFiles.findIndex(
        file => file.index === action.index
      );

      if (indexOf < 0) {
        updatedFiles.push(action.selectedFile);
      } else {
        // there is a file with same index so we are replacing the file
        updatedFiles.splice(indexOf, 1, action.selectedFile);
      }

      return {
        ...state,
        selectedFiles: updatedFiles
      };
    }
    case REMOVE_SINGLE_FILE: {
      const updatedFiles = state.selectedFiles.filter(
        file => file.index !== action.index
      );
      return {
        ...state,
        selectedFiles: updatedFiles
      };
    }
    case FILE_UPLOAD_START:
      return {
        ...state,
        uploading: true
      };
    case FILE_UPLOAD_SUCCESS: {
      const lastUploaded = state.selectedFiles.map(file =>
        Object.assign(file, { uploaded: true })
      );

      const uploadedFiles = [...state.uploadedFiles, ...lastUploaded];
      return {
        ...state,
        uploadedFiles,
        uploading: false,
        uploadError: false,
        selectedFiles: []
      };
    }
    case FILE_UPLOAD_ERROR: {
      return {
        ...state,
        uploading: false,
        uploadError: true
      };
    }
    default:
      return state;
  }
};

export default uploaderReducer;
